// extracted by mini-css-extract-plugin
export default {"elements_center":"loading-modal_elements_center__b-JKW","preloader":"loading-modal_preloader__bhqkg"};